import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../context/useAppContext";
import classNames from "classnames";
import { CopyToClipboard } from "react-copy-to-clipboard";

const fileDownload = require("js-file-download");

function Modal({ openModal, showModal }) {
  const [{ iconToPreview }] = useContext(AppContext);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const interval = setInterval(() => {
        setCopied(false);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [copied]);

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 h-screen w-full flex justify-center items-start md:items-center pt-10 md:pt-0">
          <div className="top-1/2 transform -translate-y-full relative w-300 bg-white rounded shadow-lg transition-opacity transition-transform duration-300">
            <div className="px-4 py-3 border-b border-gray-200">
              <h2 className="text-md font-semibold text-gray-600">
                {iconToPreview.name}
              </h2>
            </div>

            {iconToPreview.svg && iconToPreview.svg !== "" ? (
              <>
                <div
                  className={classNames("icon-preview", {
                    "show-preview":
                      iconToPreview !== undefined &&
                      iconToPreview.svg !== undefined,
                  })}
                >
                  <div className="ratio-container">
                    <div className="inner-container w-40 m-auto p-6">
                      <img
                        src={`data:image/svg+xml,${encodeURIComponent(
                          iconToPreview.svg
                        )}`}
                        className="w-32 h-32 text-center"
                        alt="selected icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="preview-actions">
                  <div className="px-4 py-3 border-t border-gray-200 w-full flex justify-end items-center gap-3">
                    <CopyToClipboard
                      text={iconToPreview.svg}
                      onCopy={() => setCopied(true)}
                    >
                      <button
                        onClick={() => setCopied(true)}
                        className={
                          "text-md bg-green-500 hover:bg-green-600 px-4 py-2 rounded text-white focus:outline-none " +
                          classNames({ "is-copied": copied })
                        }
                      >
                        {copied ? (
                          <span className="icon-wrapper">
                            <span>Copied</span>
                          </span>
                        ) : (
                          <span className="icon-wrapper">
                            <span>Copy</span>
                          </span>
                        )}
                      </button>
                    </CopyToClipboard>

                    <button
                      className="text-md bg-green-500 hover:bg-green-600 px-4 py-2 rounded text-white focus:outline-none"
                      onClick={() =>
                        fileDownload(
                          iconToPreview.svg,
                          `${iconToPreview.name}.svg`
                        )
                      }
                    >
                      <span className="text-md bg-green-500 hover:bg-green-600 px-4 py-2 rounded text-white focus:outline-none">
                        <span>Download</span>
                      </span>
                    </button>
                    <button
                      onClick={openModal}
                      className=" text-md bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white focus:outline-none"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <span className="no-preview-msg">Preview is not available</span>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Modal;
